export default __webpack_public_path__ + "static/gs-2b-reviewgeneratedcode-e7b510eadfcc6e215798445f59204071.jpg";